/*
 * Copyright (c) 2023, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import loadable from '@loadable/component'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
// Components
import {Skeleton} from '@salesforce/retail-react-app/app/components/shared/ui'
import {configureRoutes} from '@salesforce/retail-react-app/app/utils/routes-utils'
import {routes as _routes} from '@salesforce/retail-react-app/app/routes'
const fallback = <Skeleton height="75vh" width="100%" />

// Create your pages here and add them to the routes array
// Use loadable to split code into smaller js chunks
const Home = loadable(() => import('./pages/home'), {fallback})
const Account = loadable(() => import('./pages/account'), {fallback})
const Cart = loadable(() => import('./pages/cart'), {fallback})
const Checkout = loadable(() => import('./pages/checkout'), {fallback})
const ResetPassword = loadable(() => import('./pages/reset-password'), {fallback})
const PageViewer = loadable(() => import('./pages/page-viewer'), {fallback})
const Styleguide = loadable(() => import('./pages/styleguide'), {fallback})
const PageNotFound = loadable(() => import('./pages/page-not-found'), {fallback})
const ProductDetail = loadable(() => import('./pages/product-detail'), {fallback})
const ContactUs = loadable(() => import('./pages/contact-us'), {fallback})

const CheckoutConfirmation = loadable(() => import('./pages/checkout/confirmation'), {
    fallback: fallback
})

const CheckoutRedirect = loadable(() => import('./pages/checkout/redirect'), {
    fallback: fallback
})

const CheckoutError = loadable(() => import('./pages/checkout/error'), {
    fallback: fallback
})

const filteredDefaultRoutes = _routes.filter((route) => route.path !== '*')
const routes = [
    {
        path: '/',
        component: Home,
        exact: true
    },
    {
        path: '/account',
        component: Account
    },
    {
        path: '/cart',
        component: Cart,
        exact: true
    },
    {
        path: '/contact',
        component: ContactUs,
        exact: true
    },
    {
        path: '/reset-password',
        component: ResetPassword,
        exact: true
    },
    {
        path: '/page-viewer/:pageId',
        component: PageViewer
    },
    {
        path: '/styleguide',
        component: Styleguide
    },
    {
        path: '/product/:productId',
        component: ProductDetail
    },
    {
        path: '/checkout',
        component: Checkout,
        exact: true
    },
    {
        path: '/checkout/redirect',
        component: CheckoutRedirect
    },
    {
        path: '/checkout/error',
        component: CheckoutError
    },
    {
        path: '/checkout/confirmation/:orderNo',
        component: CheckoutConfirmation
    },
    ...filteredDefaultRoutes,
    {
        path: '*',
        component: PageNotFound
    }
]

export default () => {
    const config = getConfig()
    return configureRoutes(routes, config, {
        ignoredRoutes: ['/callback', '*']
    })
}
